import { findIndex, cloneDeep } from "lodash"
import {
  CHECK_BALANCE_HB,
  REMOVE_TUBE_FROM_HEATBLOCK_HB,
  TEMPREATURE_BALANCE_HB,
  TOGGLE_HEATBLOCK_MODAL_HB,
  TOOLTIP_DISPLAY_HB,
  TOOLTIP_REMOVE_HB,
  TUBE_TOOLTIP_DISPLAY_HB,
  TUBE_TOOLTIP_REMOVE_HB,
  UPDATE_TEMPERATURE_HB,
  TUBE_DROP_HB,
} from "../../Redux.constants";

const templateState = {
  id: -1,
  type: null,
  temperature: 30,
  currentTemp: 30,
  balance: undefined,
  isModalOpen: false,
  filledSlots: 0,
  slots: [
    { slotId: 0, tube: false, solutionId: null, defaultProps: null },
    { slotId: 1, tube: false, solutionId: null, defaultProps: null },
    { slotId: 2, tube: false, solutionId: null, defaultProps: null },
    { slotId: 3, tube: false, solutionId: null, defaultProps: null },
    { slotId: 4, tube: false, solutionId: null, defaultProps: null },
    { slotId: 5, tube: false, solutionId: null, defaultProps: null },
    { slotId: 6, tube: false, solutionId: null, defaultProps: null },
    { slotId: 7, tube: false, solutionId: null, defaultProps: null },
  ],
  tooltip: true,
  tubeTooltip: false,
  isHeating: false
};

export function HeatBlockReducer(state = { heatBlocks: [] }, action) {
  let currentHeatBlock;
  let protocolSection = state.protocolSection;

  if (action.payload === undefined) {
    return state;
  }

  if (action.type !== "CREATE_HEAT_BLOCK" && !action.type.includes("@redux")) {
    if (action.payload.hasOwnProperty("id")) {
      if (state.protocolSection.scene.apparatus.hasOwnProperty("heatBlocks")) {
        currentHeatBlock = state.protocolSection.scene.apparatus.heatBlocks[findIndex(state.protocolSection.scene.apparatus.heatBlocks, { id: action.payload.id })]
      }
    }
  }

  switch (action.type) {

    case 'CREATE_HEAT_BLOCK':

      //Create new obj from template state
      let newObj = { ...templateState, ...action.payload.props }

      if (protocolSection.scene.apparatus.hasOwnProperty("heatBlocks")) {
        protocolSection.scene.apparatus.heatBlocks = [...protocolSection.scene.apparatus.heatBlocks, newObj]
      } else {
        protocolSection.scene.apparatus.heatBlocks = [newObj]
      }

      return {
        ...state, ...{
          protocolSection: protocolSection
        }
      }

    case TOGGLE_HEATBLOCK_MODAL_HB:
      currentHeatBlock.isModalOpen = !currentHeatBlock.isModalOpen
      return updateState();

    case TUBE_TOOLTIP_DISPLAY_HB:
    case TOOLTIP_REMOVE_HB:
      currentHeatBlock.tooltip = false
      currentHeatBlock.tubeTooltip = true
      return updateState();

    case TUBE_TOOLTIP_REMOVE_HB:
    case TOOLTIP_DISPLAY_HB:
      currentHeatBlock.tooltip = true
      currentHeatBlock.tubeTooltip = false
      return updateState();


    case UPDATE_TEMPERATURE_HB:
      const TEMPREATURE = { MAX: 100, MIN: -100 };
      if (action.payload.data <= TEMPREATURE.MAX && action.payload.data >= TEMPREATURE.MIN) {
        currentHeatBlock.temperature = action.payload.data;
        currentHeatBlock.isHeating = true
      }
      return updateState();


    case TUBE_DROP_HB:
      return onTubeDrop(state, action.payload);


    case CHECK_BALANCE_HB:
      if (currentHeatBlock.temperature == currentHeatBlock.currentTemp) {
        currentHeatBlock.balance = true;
      } else {
        currentHeatBlock.balance = false;
      }
      return updateState();


    case TEMPREATURE_BALANCE_HB:
      currentHeatBlock.currentTemp = currentHeatBlock.temperature;
      const filteredTubesList = currentHeatBlock.testTubes?.map((testTube) => {
        if (testTube.display === 'none') {
          testTube.temperature = currentHeatBlock.currentTemp;
        }
        return testTube;
      });
      currentHeatBlock.balance = true;
      currentHeatBlock.testTubes = filteredTubesList;
      currentHeatBlock.isHeating = false;
      return updateState();



    case REMOVE_TUBE_FROM_HEATBLOCK_HB:
      currentHeatBlock.filledSlots = 0
      currentHeatBlock.slots = [
        { slotId: 0, tube: false, solutionId: null, defaultProps: null },
        { slotId: 1, tube: false, solutionId: null, defaultProps: null },
        { slotId: 2, tube: false, solutionId: null, defaultProps: null },
        { slotId: 3, tube: false, solutionId: null, defaultProps: null },
        { slotId: 4, tube: false, solutionId: null, defaultProps: null },
        { slotId: 5, tube: false, solutionId: null, defaultProps: null },
        { slotId: 6, tube: false, solutionId: null, defaultProps: null },
        { slotId: 7, tube: false, solutionId: null, defaultProps: null },
      ]
      return updateState();

    return removeTubeFromHeatblock(state);

    default:
      return state;
  }

  function onTubeDrop(state, payload) {
    currentHeatBlock.filledSlots = currentHeatBlock.filledSlots + 1
    const currentSlots = currentHeatBlock.slots

    for(let slotIndex = 0; slotIndex < currentSlots.length; slotIndex++){
      if(!currentSlots[slotIndex].tube){
        currentSlots[slotIndex] = {...currentSlots[slotIndex], tube: true, solutionId: payload.solutionId, defaultProps: payload.defaultProps }
        break;
      }
    }

    currentHeatBlock.slots = currentSlots
    return updateState();
  };

  function checkBalance(state) {
    if (state.temperature == state.currentTemp) {
      return { ...state, balance: true };
    } else {
      return { ...state, balance: false };
    }
  };

  function temperatureBalance(state) {
    state.currentTemp = state.temperature;
    const filteredTubesList = state.testTubes?.map((testTube) => {
      if (testTube.display === 'none') {
        testTube.temperature = state.currentTemp;
      }
      return testTube;
    });
    return {
      ...state,
      balance: true,
      testTubes: filteredTubesList,
      isHeating: false,
    };
  };

  function removeTubeFromHeatblock(state) {

    updateRemovedSlots(state);
    return {
      ...state,
      testTubes: removedTesttubeList,
      filledSlots: 0,
    };
  };

  function updateRemovedSlots(state) {
    const removedLSlotList = state.slots?.map((slot) => {
      slot.tube = false;
      return slot;
    });
    return { ...state, slots: removedLSlotList };
  };

  function updateState() {
    protocolSection.scene.apparatus.heatBlocks[findIndex(state.heatBlocks, { id: action.payload.id })] = currentHeatBlock;
    return { ...state, ...{ protocolSection: protocolSection } };
  }

}

